
// frontend/src/hooks/useGeoLocation.js
import { useState, useEffect } from 'react';

export const useGeoLocation = () => {
    const [region, setRegion] = useState('US'); // Default to US
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            // zero-latency detection using Timezone
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

            if (tz.startsWith('Europe/')) {
                if (tz.includes('London')) setRegion('GB');
                else if (tz.includes('Madrid')) setRegion('ES');
                else if (tz.includes('Berlin')) setRegion('DE');
                else if (tz.includes('Rome')) setRegion('IT');
                else setRegion('EU'); // Generic Europe
            } else if (tz.startsWith('America/')) {
                if (tz.includes('Toronto') || tz.includes('Vancouver') || tz.includes('Montreal')) {
                    setRegion('CA');
                } else if (tz.includes('Sao_Paulo')) {
                    setRegion('BR');
                } else {
                    setRegion('US');
                }
            } else if (tz.startsWith('Australia/')) {
                setRegion('AU');
            } else {
                setRegion('GLOBAL');
            }
        } catch (e) {
            console.error('Geo-detection failed', e);
        } finally {
            setLoading(false);
        }
    }, []);

    return { region, loading };
};

export const getRegionInfo = (countryCode) => {
    switch (countryCode) {
        case 'US': return { id: 'usa', name: 'United States', demonym: 'American' };
        case 'GB': return { id: 'uk', name: 'United Kingdom', demonym: 'British' };
        case 'CA': return { id: 'canada', name: 'Canada', demonym: 'Canadian' };
        case 'AU': return { id: 'australia', name: 'Australia', demonym: 'Australian' };
        default: return null;
    }
};
